import React, { useState, useEffect } from 'react';
import './scrollToTopButton.css'

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scroll
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <button
        className='scrollToTopButton'
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i class="fa-solid fa-angle-up"></i>
        </button>
      )}
    </div>
  );
};


export default ScrollToTopButton;
